export default __webpack_public_path__ + "static/nest-46df5a45ddb3e8048c857ab3192545b4.svg";